import "../components/swalStyle/customStyle.css";
import { getInstance } from "./baseapi";
import Swal from "sweetalert2";

const instance = getInstance();

export const createAndUpdateAboutus = async (body) => {
    try {
        const formData = new FormData()
        formData.append('company_profile_en', body.company_profile_en)
        formData.append('company_profile_th', body.company_profile_th)
        formData.append('company_vission_en', body.company_vission_en)
        formData.append('company_vission_th', body.company_vission_th)
        formData.append('company_background_th', body.company_background_th)
        formData.append('company_background_en', body.company_background_en)
        formData.append('detail_list', JSON.stringify(body.detail_list))
        formData.append('detail_title_th', body.detail_title_th)
        formData.append('detail_description_en', body.detail_description_en)
        formData.append('detail_description_th', body.detail_description_th)
        if (body.image_company_background.length > 0) {
            if(body.image_company_background[0].file?.file){
                const blob = new Blob([body.image_company_background[0].file?.file], { type: body.image_company_background[0].file?.file.type });
                const parts = body.image_company_background[0].file?.src.split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: "image/jpg",
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.image_company_background[0].file.size
                });

                formData.append('image_company_background', file)
            }
            else{
                formData.append('image_company_background', body.image_company_background[0].file)
            }
        }
        else{
            formData.append('image_company_background', null)
        }
        if (body.image_vission.length > 0) {
            if(body.image_vission[0].file?.file){
                const blob = new Blob([body.image_vission[0].file?.file], { type: body.image_vission[0].file?.file.type });
                const parts = body.image_vission[0].file?.src.split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: "image/jpg",
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.image_vission[0].file.size
                });

                formData.append('image_vission', file)
            }
            else{
                formData.append('image_vission', body.image_vission[0].file)
            }
        }
        else{
            formData.append('image_vission', null)
        }
        if (body.privacy_file.length > 0) {
            if(body.privacy_file[0].file?.file){
                const blob = new Blob([body.privacy_file[0].file?.file], { type: body.privacy_file[0].file?.file.type });
                const parts = body.privacy_file[0].file?.src.split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: "application/pdf",
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.privacy_file[0].file.size
                });

                formData.append('privacy_file', file)
            }
            else{
                formData.append('privacy_file', body.privacy_file[0].file)
            }
        }
        else{
            formData.append('privacy_file', null)
        }

        const rs = await instance.post(`/api/mgr/aboutus`, formData, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });

        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            throw new Error(`error durring fetch api`);
        }

        // return true
    } catch (error) {
        throw error;
    }
};

export const getDataAboutUs = async (body) => {
    try {

        const rs = await instance.get(`/api/mgr/aboutus`, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });
        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            throw new Error(`error durring fetch api`);
        }
        // return true
    } catch (error) {
        throw error;
    }
};

export const getContactUs = async () => {
    try {
        const rs = await instance.get(`/api/mgr/contactus`, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });
        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            throw new Error(`error durring fetch api`);
        }
    } catch (error) {
        console.log('found error', error)
    }
}

export const getDataHome = async (body) => {
    try {
        const rs = await instance.get(`/api/mgr/home`, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });
        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            throw new Error(`error durring fetch api`);
        }
        // return true
    } catch (error) {
        throw error;
    }
};

export const createAndUpdateContactUs = async (body) => {
    try {
        const formData = new FormData()
        formData.append('address_en', body.address_en)
        formData.append('address_th', body.address_th)
        formData.append('email', body.email)
        formData.append('tel', body.tel)
        formData.append('fax', body.fax)
        formData.append('mobile', body.mobile)
        formData.append('lat', body.lat)
        formData.append('long', body.long)
        if (body.map_img.length > 0) {
            if(body.map_img[0].file?.file){
                const blob = new Blob([body.map_img[0].file?.file], { type: body.map_img[0].file?.file.type });
                const parts = body.map_img[0].file?.src.split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: "image/jpg",
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.map_img[0].file.size
                });

                formData.append('map_img', file)
            }
            else{
                formData.append('map_img', body.map_img[0].file)
            }
        }
        else{
            formData.append('map_img', null)
        }
        formData.append('email_office', body.email_office)
        formData.append('cc_email_office', body.cc_email_office ?? '')
        formData.append('email_retail', body.email_retail)
        formData.append('cc_email_retail', body.cc_email_retail ?? '')
        formData.append('email_condo_sale', body.email_condo_sale)
        formData.append('cc_email_condo_sale', body.cc_email_condo_sale ?? '')
        formData.append('email_condo_rent', body.email_condo_rent)
        formData.append('cc_email_condo_rent', body.cc_email_condo_rent ?? '')
        formData.append('email_cs_care', body.email_cs_care)
        formData.append('cc_email_cs_care', body.cc_email_cs_care ?? '')

        const rs = await instance.post(`/api/mgr/contactus`, formData, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });
        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            throw new Error(`error durring fetch api`);
        }
    } catch (error) {
        console.log('found error ', error)
    }
}

export const createAndUpdateHome = async (body) => {
    try {
        const formData = new FormData()
        formData.append('asp_description_en', body.asp_description_en)
        formData.append('asp_description_th', body.asp_description_th)
        formData.append('asp_virtual_link', body.asp_virtual_link)
        formData.append('conrad_link', body.conrad_link)
        formData.append('offfice_description_en', body.offfice_description_en)
        formData.append('offfice_description_th', body.offfice_description_th)
        formData.append('retail_description_en', body.retail_description_en)
        formData.append('retail_description_th', body.retail_description_th)
        formData.append('condo_description_en', body.condo_description_en)
        formData.append('condo_description_th', body.condo_description_th)
        formData.append('conrad_description_en', body.conrad_description_en)
        formData.append('conrad_description_th', body.conrad_description_th)
        formData.append('career_description_en', body.career_description_en)
        formData.append('career_description_th', body.career_description_th)
        if (body.office_image.length > 0) {
            if(body.office_image[0].file?.file){
                const blob = new Blob([body.office_image[0].file?.file], { type: body.office_image[0].file?.file.type });
                const parts = body.office_image[0].file?.src[0].split('/') //from api
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: "image/jpg",
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.office_image[0].file.size
                });

                formData.append('office_image', file)
            }
            else{
                formData.append('office_image', body.office_image[0].file) // select new
            }
        }
        else{
            formData.append('office_image', null)
        }
        if (body.retail_image.length > 0) {
            if(body.retail_image[0].file?.file){
                const blob = new Blob([body.retail_image[0].file?.file], { type: body.retail_image[0].file?.file.type });
                const parts = body.retail_image[0].file?.src[0].split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: "image/jpg",
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.retail_image[0].file.size
                });

                formData.append('retail_image', file)
            }
            else{
                formData.append('retail_image', body.retail_image[0].file)
            }
        }
        else{
            formData.append('retail_image', null)
        }
        if (body.condo_image.length > 0) {
            if(body.condo_image[0].file?.file){
                const blob = new Blob([body.condo_image[0].file?.file], { type: body.condo_image[0].file?.file.type });
                const parts = body.condo_image[0].file?.src[0].split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: "image/jpg",
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.condo_image[0].file.size
                });

                formData.append('condo_image', file)
            }
            else{
                formData.append('condo_image', body.condo_image[0].file)
            }
        }
        else{
            formData.append('condo_image', null)
        }
        if (body.conrad_image.length > 0) {
            if(body.conrad_image[0].file?.file){
                const blob = new Blob([body.conrad_image[0].file?.file], { type: body.conrad_image[0].file?.file.type });
                const parts = body.conrad_image[0].file?.src[0].split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: "image/jpg",
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.conrad_image[0].file.size
                });

                formData.append('conrad_image', file)
            }
            else{
                formData.append('conrad_image', body.conrad_image[0].file)
            }
        }
        else{
            formData.append('conrad_image', null)
        }
        if (body.career_image.length > 0) {
            if(body.career_image[0].file?.file){
                const blob = new Blob([body.career_image[0].file?.file], { type: body.career_image[0].file?.file.type });
                const parts = body.career_image[0].file?.src[0].split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: "image/jpg",
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.career_image[0].file.size
                });

                formData.append('career_image', file)
            }
            else{
                formData.append('career_image', body.career_image[0].file)
            }
        }
        else{
            formData.append('career_image', null)
        }

        const rs = await instance.post(`/api/mgr/home`, formData, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });
        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            return null;
        }
    } catch(error) {
        Swal.fire({
            icon: "error",
            title: error.response.data.message,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
}